import * as types from '../actionTypes';

export function setLoginPending(isLoading) {
  return {
    type: types.APP_LOAD,
    isLoading,
  };
}

export function setLoginSuccess(isLoading, user, data, token) {
  return {
    type: types.SET_LOGIN_SUCCESS,
    isLoading,
    user,
    data,
    token,
  };
}

export function setLoginError(isLoading, error) {
  return {
    type: types.SET_LOGIN_ERROR,
    isLoading,
    error,
  };
}

export function setLoginDisable(isLoading, data) {
  return {
    type: types.SET_DISABLE_USER_SIGNIN,
    isLoading,
    data,
  };
}

export function setLoginFailed(isLoading) {
  return {
    type: types.UNAUTH_USER,
    isLoading,
  };
}

export function signOutAction() {
  localStorage.removeItem('access_token');
  localStorage.clear();
  return {
    type: types.LOGOUT,
  };
}

export function reset() {
  return {
    type: types.RESET,
  };
}

export function setErrorPage(isLoading, error) {
  return {
    type: types.SET_ERROR,
    isLoading,
    error,
  };
}

export function setAgentRemoveInfoError() {
  return {
    type: types.SET_REMOVE_ERROR,
  };
}
